import { Mtds, SinglePlan } from 'prove-common'
import { PlanCard } from '../plan-card/PlanCard'

type PlansTabProps = {
  plans: SinglePlan[]
}

export const PlansTab = ({ plans }: PlansTabProps) => {
  return (
    <Mtds.Grid>
      <Mtds.Heading as='h2' data-size='sm'>
        Planer <Mtds.Badge data-badge={plans.length} />
      </Mtds.Heading>
      {plans.map((plan) => {
        return <PlanCard key={plan.id} plan={plan} />
      })}
    </Mtds.Grid>
  )
}
